import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { AuthService } from '../../../core/services/auth.service';

@Component({
  selector: 'tm-login-layout',
  imports: [RouterOutlet, AvatarModule, ButtonModule],
  templateUrl: './login-layout.component.html',
  styleUrl: './login-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginLayoutComponent {
  protected readonly auth = inject(AuthService);
  protected readonly currentYear = new Date().getFullYear();

  onSwitchUser(): void {
    this.auth.logout();
    window.location.pathname = '/';
  }
}
